import { useEditCourseGoBack } from "@/hooks/ui/useEditCourseRoute";
import { RouteOptionsById, router, RouterIds } from "@vixi/router";

const routeId = "/_app/courses/$courseId/see-analytics" satisfies RouterIds;
const Route = router.routesById[routeId];

export const SeeAnalyticsPageOptions: RouteOptionsById<typeof routeId> = {
  component: RouteComponent,
};

function RouteComponent() {
  useEditCourseGoBack();

  return "Hello /app/courses/$courseId/see-analytics!";
}
